import { render, staticRenderFns } from "./TactfulTelInput.vue?vue&type=template&id=5cbcdb2c"
import script from "./TactfulTelInput.vue?vue&type=script&lang=ts"
export * from "./TactfulTelInput.vue?vue&type=script&lang=ts"
import style0 from "./TactfulTelInput.vue?vue&type=style&index=0&id=5cbcdb2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports